import {Component, Input, OnInit} from '@angular/core';
import {PropertyService} from "../../../views/app/properties/property.service";
import {GlobalService} from "../../global.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-learning-article',
  templateUrl: './learning-article.component.html',
  styleUrls: ['./learning-article.component.scss']
})
export class LearningArticleComponent implements OnInit {
  @Input() formId = null;
  @Input() comeFrom = null;
  articles: any = [];
  myWindow:any;
  constructor(
    private propertyService: PropertyService,
    private globalService: GlobalService,
    private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit(): void {
    this.getLearningArticleList();
  }

  public getLearningArticleList() {
    this.spinner.show();
    let articleData = {
      'keyWord': null,
      'form_id': this.formId,
      'article_ref':null,
      'from_form': this.comeFrom,
    };

    this.propertyService.countProppelLearningArticleView(articleData).subscribe(res => {
      this.articles =  res['learning_articles'];
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      this.globalService.onError(err);
    });
  }

  alertWindowOpen(data) {
    // this.articleModel.hide();
    this.myWindow = window.open("", data['title'], "width=800,height=600");
    this.myWindow.document.write(`
  <html>
    <head>
      <title>${data['content_title']}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        .close-btn { margin-top: 20px; padding: 4px 20px; background-color: #008ecc !important; color: white; border: none; cursor: pointer; border-radius: 5px; float: right; margin-bottom: 20px;}
      </style>
    </head>
    <body>
      ${data['content']}
      <button class="close-btn" onclick="window.close()">Close</button>
    </body>
  </html>
`);
    let articleData = {
      'keyWord': null,
      'form_id':this.formId,
      'article_ref':data['article_ref'],
      'from_form':'form',
    };

    this.propertyService.countProppelLearningArticleView(articleData).subscribe(res => {
      this.articles =  res['learning_articles'];
    }, err => {
      this.spinner.hide();
      this.globalService.onError(err);
    });
  }
}
